var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8999 41.6501C4.8999 41.0702 5.37 40.6001 5.9499 40.6001H25.5499C26.1298 40.6001 26.5999 41.0702 26.5999 41.6501C26.5999 42.23 26.1298 42.7001 25.5499 42.7001H5.9499C5.37 42.7001 4.8999 42.23 4.8999 41.6501Z",
    fill: "#CED4DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1998 15.5574C45.4999 15.5574 44.8287 15.8349 44.3338 16.3289L42.8718 17.7881L46.6038 21.5132L48.0658 20.054C48.5607 19.56 48.8387 18.89 48.8387 18.1914C48.8387 17.4928 48.5607 16.8229 48.0658 16.3289C47.5709 15.8349 46.8997 15.5574 46.1998 15.5574ZM49.6649 21.6502C50.5839 20.7329 51.1002 19.4887 51.1002 18.1914C51.1002 16.8942 50.5839 15.65 49.6649 14.7327C48.7459 13.8154 47.4995 13.3 46.1998 13.3C44.9001 13.3 43.6537 13.8154 42.7347 14.7327L40.4739 16.9893C40.4736 16.9896 40.4741 16.9891 40.4739 16.9893C40.4736 16.9896 40.4727 16.9905 40.4724 16.9907L22.0314 35.3978C21.8193 35.6095 21.7002 35.8966 21.7002 36.1959V41.5714C21.7002 42.1947 22.2064 42.7001 22.8309 42.7001H28.1078C28.4077 42.7001 28.6953 42.5811 28.9073 42.3695L49.6649 21.6502ZM45.0047 23.1094L41.2727 19.3843L23.9617 36.6634V40.4427H27.6394L45.0047 23.1094Z",
    fill: "#DEE2E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilSign);
export default __webpack_public_path__ + "static/media/pencil_sign.d34fd4e6195fe5f314a02e718864d928.svg";
export { ForwardRef as ReactComponent };